
import { ActionModel } from '../../Models/action-model';

export class ActionMocks {

  private static models: ActionModel[];
  private static  idCounter = 0;

  public static initMocks(){
    ActionMocks.models = [];
    ActionMocks.models.push({aId :++this.idCounter, _id: "weggmccgygyygg", name: "is on", objectTypes: ["page"],accepts:["target","value"]});
    ActionMocks.models.push({aId :++this.idCounter, _id: "jhegumygt44756", name: "enter text in" , objectTypes: ["input"],accepts:["target"]});
    ActionMocks.models.push({aId :++this.idCounter, _id: "erjwwmbwbgbwe4", name: "clicks on"  , objectTypes: ["input,button,image"],accepts:["value"]});
    ActionMocks.models.push({aId :++this.idCounter, _id: "erjwasdcasdfas", name: "drag and drops "  , objectTypes: ["input,button,image"],accepts:["value","value"]});
 }

  public static findByObjectId(id: string):ActionModel{
    let m = ActionMocks.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i]._id) return m[i];
    }
    return null;
  }

  public static findById(id:number):ActionModel{
    let m = ActionMocks.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].aId) return m[i];
    }
    return null;
  }

  public static getItems():ActionModel[]{
    return ActionMocks.models;
  }

}
